// autogenerated by supabase/schemas/logging.rb - do not edit

/** Tables with log_changes triggers; realtime uses account broadcast instead of postgres_changes. */
export const BROADCAST_CAPABLE_TABLES = new Set<string>([
  "account_users",
  "clubs",
  "club_akahu_connections",
  "club_permissions",
  "groups",
  "club_players",
  "club_player_memberships",
  "club_documents",
  "club_player_accepted_documents",
  "recurring_sessions",
  "session_intents",
  "tokens",
  "nights",
  "players",
  "account_features",
  "club_player_tokens",
  "feedback_messages",
  "fill_rules",
  "game_sets",
  "games",
  "incident_logs",
  "invites",
  "notes",
  "player_game_stats",
  "player_ratings",
  "token_notifications",
  "tournament_sessions",
  "tournament_competitions",
  "tournament_entries",
  "tournament_matches",
  "tournament_competition_events",
  "tournament_competition_state_snapshots",
  "tournament_competition_conflicts",
  "tournament_payment_methods",
  "tournament_players",
  "tournament_registrations",
  "user_notification_preferences",
  "funders",
  "funding_appeals",
  "funding_appeal_email_templates",
  "funding_outreach",
  "funding_outreach_communications",
  "funding_outreach_communication_analyses",
  "funding_outreach_communication_reads",
  "funding_scout_runs",
  "funding_scout_prospects",
  "funding_scout_prospect_sources",
]);

export function isBroadcastCapableTable(tableName: string): boolean {
  return BROADCAST_CAPABLE_TABLES.has(tableName);
}
